import { render, staticRenderFns } from "./WelcomeMessageList.vue?vue&type=template&id=41ad70b8&"
import script from "./WelcomeMessageList.vue?vue&type=script&lang=js&"
export * from "./WelcomeMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports